export const IMAGES = {
  heroBottle: "/assets/hero-bottle.jpg",
  heroInfographic: "/assets/hero-infographic.jpg",
  dropper: "/assets/dropper.jpg",
  offer: "/assets/offer.jpg",
  before: "/assets/before.jpg",
  after: "/assets/after.jpg",
  texture: "/assets/texture.jpg",
  packaging: "/assets/packaging.jpg",
  marque: "/assets/marque.jpg",
  ritual: "/assets/ritual.jpg",
  femmeBottle: "/assets/femme-bottle.jpg",
  femmeDropper: "/assets/femme-dropper.jpg",
  femmeOffer: "/assets/femme-offer.jpg",
  femmeDuo: "/assets/femme-duo.jpg",
  femmeRitual: "/assets/femme-ritual.jpg",
  hommeRitual: "/assets/homme-ritual.jpg",
  hommeBoard: "/assets/homme-board.jpg",
  femmeBoard: "/assets/femme-board.jpg",
  landingFemme: "/assets/landing-femme.jpg",
  landingHomme: "/assets/landing-homme.jpg",
  coffretMixte: "/assets/coffret-mixte.jpg",
  coffretFemme: "/assets/coffret-femme.jpg",
  coffretHomme: "/assets/coffret-homme.jpg",
  beard: "/assets/beard.jpg",
  coffrets: "/assets/coffrets.jpg",
  hommeResult1: "/assets/homme-result-1.jpg",
  hommeResult2: "/assets/homme-result-2.jpg",
  hommeResult3: "/assets/homme-result-3.jpg",
  femmeResult1: "/assets/femme-result-1.jpg",
  femmeResult2: "/assets/femme-result-2.jpg",
  ingredientHoney: "/assets/ingredients/ingredient-honey.jpg",
  ingredientCaffeine: "/assets/ingredients/ingredient-caffeine.jpg",
  ingredientNiacinamide: "/assets/ingredients/ingredient-niacinamide.jpg",
  ingredientArgan: "/assets/ingredients/ingredient-argan.jpg",
};

// Images produit adaptées à l'univers (Femme = rose gold, Homme = noir/or).
// `IMG` permet d'injecter la map d'images fusionnée avec les surcharges admin (CMS).
export const productImages = (universe, IMG = IMAGES) =>
  universe === "femme"
    ? {
        gallery: [IMG.femmeBottle, IMG.femmeBoard, IMG.femmeDropper, IMG.femmeRitual],
        single: IMG.femmeBottle,
        duo: IMG.femmeDuo,
      }
    : {
        gallery: [IMG.heroBottle, IMG.hommeBoard, IMG.texture, IMG.hommeRitual],
        single: IMG.heroBottle,
        duo: IMG.packaging,
      };

export const HERO_BENEFITS = [
  { title: "Brillance immédiate", icon: "Sparkles" },
  { title: "Favorise la pousse", icon: "Sprout" },
  { title: "Nourrit & fortifie", icon: "ShieldCheck" },
  { title: "Effet miroir anti-frisottis", icon: "Sparkles" },
];

export const HERO_BADGES = [
  { label: "Nouvelle génération", icon: "Crown" },
  { label: "Miel & actifs fortifiants", icon: "Droplet" },
  { label: "Brillance glossy immédiate", icon: "Sparkles" },
  { label: "20 ml", icon: "Gem" },
  { label: "Qualité premium", icon: "Crown" },
];

export const TRUST_STRIP = [
  { title: "Brillance immédiate", text: "Un fini glossy et lumineux dès l'application", icon: "Sparkles" },
  { title: "Force & résistance", text: "Des actifs sélectionnés pour la fibre capillaire", icon: "ShieldCheck" },
  { title: "Miel & huiles précieuses", text: "Nutrition et toucher soyeux", icon: "Droplet" },
  { title: "Soin du cuir chevelu", text: "Caféine, niacinamide, ginseng & arginine", icon: "Leaf" },
];

export const WHY_CHOOSE = [
  "Brillance immédiate, effet miroir",
  "Favorise la pousse et prend soin du cuir chevelu",
  "Nourrit et fortifie la fibre capillaire",
  "Aide à limiter l'apparence des frisottis",
  "Toucher soyeux et fini glossy premium",
  "Formule pensée pour les cheveux et le cuir chevelu",
];

export const KEY_INGREDIENTS = [
  { name: "Miel", text: "Apporte une sensation de nutrition et de douceur à la chevelure.", icon: "Droplet", image: "ingredientHoney" },
  { name: "Caféine", text: "Actif sélectionné pour le soin du cuir chevelu et la routine pousse.", icon: "Zap", image: "ingredientCaffeine" },
  { name: "Niacinamide", text: "Contribue au confort et à l'équilibre du cuir chevelu.", icon: "Hexagon", image: "ingredientNiacinamide" },
  { name: "Argan", text: "Huile précieuse pour nourrir et sublimer la fibre.", icon: "Leaf", image: "ingredientArgan" },
];

export const FRAGRANCE = {
  title: "Signature olfactive",
  name: "Floral · Miellée · Douce · Lumineuse",
  text: "Une signature sensorielle florale et miellée, douce et lumineuse, qui laisse les cheveux délicatement parfumés.",
};

export const RESULTS = [
  { value: "+90%", label: "ÉCLAT VISUEL" },
  { value: "+85%", label: "TOUCHER SOYEUX" },
  { value: "+80%", label: "FORCE & RÉSISTANCE" },
  { value: "-75%", label: "APPARENCE DES FRISOTTIS" },
  { value: "100%", label: "EXPÉRIENCE GLOSSY" },
  { value: "-76%", label: "DE CHUTE DE CHEVEUX" },
];

export const PRODUCT = {
  name: "LUXE ORYVEA PREMIUM",
  subtitle: "SÉRUM CAPILLAIRE",
  volume: "20 ml / 0.67 fl oz",
  price: 29.90,
  lookupKey: "serum_regular",
};

export const VARIANTS = {
  single: { key: "serum_homme", label: "Sérum Capillaire Homme", sub: "20 ml", unit: 29.90, image: IMAGES.heroBottle },
  duo: { key: "serum_duo_homme", label: "Duo Sérum Homme", sub: "2 × 20 ml", unit: 49.90, compareAt: 59.80, image: IMAGES.packaging },
};

export const PROMISES = ["Stimule", "Renforce", "Densifie", "Hydrate", "Apaise"];

export const BENEFITS = [
  { title: "Éclat & Vitalité", text: "Pour une chevelure visiblement plus belle.", icon: "Sparkles" },
  { title: "Hydratation Intense", text: "Une texture légère qui contribue au confort du cuir chevelu.", icon: "Droplets" },
  { title: "Cuir Chevelu Soigné", text: "Un rituel quotidien dédié au cuir chevelu.", icon: "Leaf" },
  { title: "Cheveux Plus Forts", text: "Une formule pensée pour accompagner votre routine capillaire.", icon: "ShieldCheck" },
  { title: "Formule Avancée", text: "Une association d'actifs soigneusement sélectionnés.", icon: "FlaskConical" },
];

export const INGREDIENTS = [
  { name: "Miel", text: "Sublime la douceur et la nutrition pour un fini lumineux.", icon: "Droplet", key: true },
  { name: "Caféine", text: "Actif sélectionné pour le soin du cuir chevelu et la routine pousse.", icon: "Zap", key: true },
  { name: "Niacinamide", text: "Contribue au confort et à l'apparence du cuir chevelu.", icon: "Hexagon", key: true },
  { name: "Ginseng", text: "Actif végétal intégré à la routine de soin du cuir chevelu.", icon: "Sprout", key: true },
  { name: "Arginine", text: "Acide aminé qui contribue au conditionnement de la fibre.", icon: "Sparkle", key: true },
  { name: "Protéines végétales hydrolysées", text: "Aident à améliorer l'apparence de la fibre et sa sensation de résistance.", icon: "Layers", key: true },
  { name: "Panthénol", text: "Apporte souplesse, douceur et confort à la chevelure.", icon: "Droplet", key: false },
  { name: "Huile d'argan", text: "Nourrit et apporte un toucher soyeux.", icon: "Leaf", key: true },
  { name: "Huile d'amande douce", text: "Contribue à la douceur et au fini soyeux.", icon: "Leaf", key: false },
  { name: "Huile de coco", text: "Soin nourrissant de la fibre capillaire.", icon: "Leaf", key: false },
  { name: "Huile de passiflore", text: "Huile précieuse pour une finition douce et lumineuse.", icon: "Flower2", key: false },
  { name: "Vitamine E", text: "Antioxydant utilisé dans les soins capillaires.", icon: "Star", key: false },
  { name: "Dimethicone", text: "Contribue au lissage, à la brillance et au toucher soyeux.", icon: "Sparkles", key: true },
  { name: "Dimethiconol", text: "Aide à lisser la fibre et à contrôler les frisottis.", icon: "Sparkles", key: true },
  { name: "Trisiloxane", text: "Contribue à une répartition uniforme et à une finition légère.", icon: "Waves", key: false },
];

export const STEPS = [
  { n: "01", title: "Appliquez", text: "Appliquez quelques gouttes directement sur le cuir chevelu." },
  { n: "02", title: "Massez", text: "Massez délicatement du bout des doigts." },
  { n: "03", title: "Laissez agir", text: "Laissez le sérum agir et intégrez-le régulièrement à votre routine." },
];

export const FAQ = [
  { q: "Comment utiliser le sérum ?", a: "Appliquez quelques gouttes directement sur le cuir chevelu, puis massez délicatement du bout des doigts jusqu'à absorption." },
  { q: "À quelle fréquence l'utiliser ?", a: "Le sérum s'intègre facilement à une routine quotidienne. Pour de meilleurs résultats d'apparence, utilisez-le régulièrement." },
  { q: "Le sérum convient-il à tous les types de cheveux ?", a: "Sa texture légère est pensée pour s'adapter à différents types de cheveux et de cuir chevelu." },
  { q: "Le sérum est-il gras ?", a: "Non. Sa texture est légère et son fini non gras pour un confort au quotidien." },
  { q: "Quelle est sa contenance ?", a: "Le flacon contient 20 ml / 0.67 fl oz, avec une pipette pour un dosage précis." },
  { q: "Quels sont ses principaux ingrédients ?", a: "Miel, caféine, niacinamide, ginseng, arginine, protéines végétales hydrolysées, panthénol, huiles d’argan, d’amande douce, de coco et de passiflore, vitamine E, dimethicone, dimethiconol et trisiloxane." },
  { q: "Combien de temps avant d'évaluer son apparence ?", a: "Comme tout soin cosmétique, une utilisation régulière sur la durée est recommandée pour apprécier l'apparence de vos cheveux." },
  { q: "Comment conserver le produit ?", a: "Conservez le flacon à l'abri de la lumière directe et de la chaleur, bien refermé après chaque utilisation." },
];


// ---------------------------------------------------------------------------
// Traductions anglaises (EN) — helpers localisés. lang = "fr" | "en".
// ---------------------------------------------------------------------------
const EN = {
  heroBenefits: [
    "Promotes growth",
    "Intensely hydrates & nourishes",
    "Stronger & healthier hair",
    "Suitable for all hair types",
  ],
  heroBadges: [
    "Next generation",
    "Honey & strengthening actives",
    "Immediate glossy shine",
    "20 ml",
    "Premium quality",
  ],
  trustStrip: [
    { title: "Luxury & Elegance", text: "For exceptional care" },
    { title: "Advanced formulas", text: "High-performance ingredients" },
    { title: "Visible results", text: "Healthy scalp, strong & dense hair" },
    { title: "Honey & precious oils", text: "Nutrition and silky feel" },
  ],
  whyChoose: [
    "Stimulates hair growth",
    "Deeply hydrates and nourishes the scalp",
    "Strengthens the hair fiber",
    "Helps reduce hair loss",
    "Improves the appearance of density and thickness",
    "Non-greasy formula, fast absorption",
  ],
  keyIngredients: [
    { name: "Honey", text: "Nourishes the hair and enhances a luminous finish." },
    { name: "Caffeine", text: "Selected active for scalp care and a growth-focused routine." },
    { name: "Niacinamide", text: "Contributes to scalp comfort and balance." },
    { name: "Argan oil", text: "Nourishes and leaves a silky feel." },
  ],
  results: [
    { label: "VISIBLE RADIANCE" },
    { label: "SILKY FEEL" },
    { label: "STRENGTH & RESISTANCE" },
    { label: "APPEARANCE OF FRIZZ" },
    { label: "GLOSSY EXPERIENCE" },
    { label: "HAIR FALL" },
  ],
  fragrance: {
    title: "Signature fragrance",
    name: "Floral · Honeyed · Soft · Luminous",
    text: "A soft, luminous floral-honeyed signature that leaves the hair delicately scented.",
  },
  benefits: [
    { title: "Radiance & Vitality", text: "For visibly more beautiful hair." },
    { title: "Intense Hydration", text: "A lightweight texture that contributes to scalp comfort." },
    { title: "Cared-for Scalp", text: "A daily ritual dedicated to the scalp." },
    { title: "Stronger Hair", text: "A formula designed to support your hair routine." },
    { title: "Advanced Formula", text: "A blend of carefully selected active ingredients." },
  ],
  ingredients: [
    { name: "Honey", text: "Brings a nourished, soft and luminous finish." },
    { name: "Caffeine", text: "Selected active for scalp care and a growth-focused routine." },
    { name: "Niacinamide", text: "Contributes to scalp comfort and balance." },
    { name: "Ginseng", text: "Botanical active included in scalp care." },
    { name: "Arginine", text: "Amino acid that contributes to hair conditioning." },
    { name: "Hydrolyzed plant proteins", text: "Help improve the appearance and feel of hair strength." },
    { name: "Panthenol", text: "Brings softness and suppleness to the hair." },
    { name: "Argan oil", text: "Nourishes and leaves a silky feel." },
    { name: "Sweet almond oil", text: "Contributes to softness and a silky finish." },
    { name: "Coconut oil", text: "Nourishing care for the hair fiber." },
    { name: "Passionflower oil", text: "Precious oil for a soft, luminous finish." },
    { name: "Vitamin E", text: "An antioxidant used in hair care." },
    { name: "Dimethicone", text: "Contributes to smoothing, shine and silky feel." },
    { name: "Dimethiconol", text: "Helps smooth the fiber and control frizz." },
    { name: "Trisiloxane", text: "Contributes to even distribution and a lightweight finish." },
  ],
  steps: [
    { title: "Apply", text: "Apply a few drops directly onto the scalp." },
    { title: "Massage", text: "Gently massage with your fingertips." },
    { title: "Let it work", text: "Let the serum work and use it regularly as part of your routine." },
  ],
  variants: {
    single: { label: "Single bottle", sub: "20 ml" },
    duo: { label: "Duo Set", sub: "2 × 20 ml" },
  },
  faq: [
    { q: "How do I use the serum?", a: "Apply a few drops directly onto the scalp, then gently massage with your fingertips until absorbed." },
    { q: "How often should I use it?", a: "The serum fits easily into a daily routine. For the best appearance results, use it regularly." },
    { q: "Is the serum suitable for all hair types?", a: "Its lightweight texture is designed to suit different hair and scalp types." },
    { q: "Is the serum greasy?", a: "No. Its texture is light with a non-greasy finish for everyday comfort." },
    { q: "What is the volume?", a: "The bottle contains 20 ml / 0.67 fl oz, with a dropper for precise dosing." },
    { q: "What are its main ingredients?", a: "Caffeine, peptides, niacinamide, panthenol and hyaluronic acid, combined with other carefully selected actives." },
    { q: "How long before I can assess its appearance?", a: "Like any cosmetic care, regular use over time is recommended to appreciate the appearance of your hair." },
    { q: "How should I store the product?", a: "Store the bottle away from direct light and heat, tightly closed after each use." },
  ],
};

const isEn = (lang) => lang === "en";

export const heroBenefits = (lang) =>
  HERO_BENEFITS.map((b, i) => ({ ...b, title: isEn(lang) ? EN.heroBenefits[i] : b.title }));
export const heroBadges = (lang) =>
  HERO_BADGES.map((b, i) => ({ ...b, label: isEn(lang) ? EN.heroBadges[i] : b.label }));
export const trustStrip = (lang) =>
  TRUST_STRIP.map((t, i) => (isEn(lang) ? { ...t, ...EN.trustStrip[i] } : t));
export const whyChoose = (lang) => (isEn(lang) ? EN.whyChoose : WHY_CHOOSE);
export const keyIngredients = (lang) =>
  KEY_INGREDIENTS.map((k, i) => (isEn(lang) ? { ...k, ...EN.keyIngredients[i] } : k));
export const fragranceData = (lang) => (isEn(lang) ? EN.fragrance : FRAGRANCE);
export const resultsData = (lang) =>
  RESULTS.map((r, i) => (isEn(lang) ? { ...r, label: EN.results[i].label } : r));
export const benefitsData = (lang) =>
  BENEFITS.map((b, i) => (isEn(lang) ? { ...b, ...EN.benefits[i] } : b));
export const ingredientsData = (lang) =>
  INGREDIENTS.map((ing, i) => (isEn(lang) ? { ...ing, ...EN.ingredients[i] } : ing));
export const stepsData = (lang) =>
  STEPS.map((s, i) => (isEn(lang) ? { ...s, ...EN.steps[i] } : s));
export const variantsData = (lang) =>
  isEn(lang)
    ? {
        single: { ...VARIANTS.single, ...EN.variants.single },
        duo: { ...VARIANTS.duo, ...EN.variants.duo },
      }
    : VARIANTS;
export const faqData = (lang) => (isEn(lang) ? EN.faq : FAQ);

const PROMISES_EN = ["Stimulates", "Strengthens", "Densifies", "Hydrates", "Soothes"];
const VALUES_FR = ["Excellence", "Élégance", "Soin", "Qualité", "Formulation avancée", "Expérience sensorielle"];
const VALUES_EN = ["Excellence", "Elegance", "Care", "Quality", "Advanced formulation", "Sensory experience"];

export const promisesData = (lang) => (isEn(lang) ? PROMISES_EN : PROMISES);
export const valuesData = (lang) => (isEn(lang) ? VALUES_EN : VALUES_FR);
